import {
  Box,
  Button,
  Card,
  CardHeader,
  Grid,
  useMediaQuery,
  Typography,
  TextField,
  Select,
  MenuItem,
  Container,
  Switch,
  Tooltip,
  InputAdornment,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  FormControlLabel,
  CircularProgress,
  IconButton
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../hooks/use-auth";
import { paramsApi } from "../../../api/params-api";
import { useMounted } from "../../../hooks/use-mounted";
import { stepApi } from "../../../api/step-api";
import { auditsApi } from "../../../api/audit-api";
import { validate } from "json-schema";
import { set } from "lodash";
 
export const Parameters = () => {
  const { user } = useAuth();
  const isMounted = useMounted();
  const [loading, setLoading] = useState(true);
  const [automaticMail, setAutomaticMail] = useState(false);
  const [automaticMailToCustomer, setAutomaticMailToCustomer] = useState(false);
  const [automaticMailUserFirstLogin, setAutomaticMailUserFirstLogin] = useState(false);
  const [automaticMailUserNewDevice, setAutomaticMailUserNewDevice] = useState(false);
  const [automaticMailAdminFirstLogin, setAutomaticMailAdminFirstLogin] = useState(false);
  const [automaticMailAdminNewDevice, setAutomaticMailAdminNewDevice] = useState(false);

  const [autoRelaunche, setAutoRelaunche] = useState(false);
  const [autoSendMailSameEPP, setAutoSendMailSameEPP] = useState(false);


  const [modifyAppDays, setModifyAppDays] = useState(false);
  const [modifyPatientsNumber, setModifyPatientsNumber] = useState(false);
  const [modifyTLMS_BRANCH_ID, setModifyTLMS_BRANCH_ID] = useState(false);
  const [modifyTLMS_DOMAIN, setModifyTLMS_DOMAIN] = useState(false);
  const [modifyTLMS_ADDRESS, setModifyTLMS_ADDRESS] = useState(false);



  const [applicationDays, setApplicationDays] = useState(90);      const [oldApplicationDays, setOldApplicationDays] = useState(90);
  const [patientsNumber, setPatientsNumber] = useState(10);        const [oldPatientsNumber, setOldPatientsNumber] = useState(10);
  const [TLMS_BRANCH_ID, setTLMS_BRANCH_ID] = useState(10);        const [oldTLMS_BRANCH_ID, setOldTLMS_BRANCH_ID] = useState(10);
  const [TLMS_DOMAIN, setTLMS_DOMAIN] = useState("");             const [oldTLMS_DOMAIN, setOldTLMS_DOMAIN] = useState("");
  const [TLMS_ADDRESS, setTLMS_ADDRESS] = useState("");            const [oldTLMS_ADDRESS, setOldTLMS_ADDRESS] = useState("");


  const [hovered, setHovered] = useState(null);
 
  const getParams = useCallback(async () => {
    try {
      setLoading(true);
      const [
        automaticMail,
        automaticMailToCustomer,
        automaticMailUserFirstLogin,
        automaticMailUserNewDevice,
        automaticMailAdminFirstLogin,
        automaticMailAdminNewDevice,

        AutoRelaunche,
        SendMailSameEPP,
        TLMS_BRANCH_ID,
        TLMS_DOMAIN,
        TLMS_ADDRESS,
        APPLICATION_DAYS,
        PATIENTS_NUMBER
      ] = await Promise.all([
        paramsApi.getParamAutomaticMail(user.admin_id),
        paramsApi.getParamAutomaticMailToCustomer(user.admin_id),
        paramsApi.getParamAutomaticMailUserFirstLogin(user.admin_id),
        paramsApi.getParamAutomaticMailUserNewDevice(user.admin_id),
        paramsApi.getParamAutomaticMailAdminFirstLogin(user.admin_id),
        paramsApi.getParamAutomaticMailAdminNewDevice(user.admin_id),


        paramsApi.getParamAutoRelaunche(user.admin_id),
        paramsApi.getParamSendMailSameEPP(user.admin_id),
        paramsApi.getParamTLMS_BRANCH_ID(user.admin_id),
        paramsApi.getParamTLMS_DOMAIN(user.admin_id),
        paramsApi.getParamTLMS_ADDRESS(user.admin_id),
        paramsApi.getParamAPPLICATION_DAYS(user.admin_id),
        paramsApi.getParamPATIENTS_NUMBER(user.admin_id),
      ]);
 
      if (isMounted()) {
        setAutomaticMail(automaticMail.automatic_mails_send === 1);
        setAutomaticMailToCustomer(automaticMailToCustomer.automatic_mails_send_to_customer === 1);
        setAutomaticMailUserFirstLogin(automaticMailUserFirstLogin.automatic_mails_UserFirstLogin === 1);
        setAutomaticMailUserNewDevice(automaticMailUserNewDevice.automatic_mail_UserNewDevice === 1);
        setAutomaticMailAdminFirstLogin(automaticMailAdminFirstLogin.automatic_mails_AdminFirstLogin === 1);
        setAutomaticMailAdminNewDevice(automaticMailAdminNewDevice.automatic_mails_AdminNewDevice === 1);
        
        
        setAutoRelaunche(AutoRelaunche.auto_relaunche === 1);
        setAutoSendMailSameEPP(SendMailSameEPP.send_mail_same_epp === 1);

        setTLMS_BRANCH_ID(TLMS_BRANCH_ID.tlms_branch_id); setOldTLMS_BRANCH_ID(TLMS_BRANCH_ID.tlms_branch_id);
        setTLMS_DOMAIN(TLMS_DOMAIN.tlms_domain);   setOldTLMS_DOMAIN(TLMS_DOMAIN.tlms_domain);
        setTLMS_ADDRESS(TLMS_ADDRESS.tlms_address); setOldTLMS_ADDRESS(TLMS_ADDRESS.tlms_address);
        setApplicationDays(APPLICATION_DAYS.application_days); setOldApplicationDays(APPLICATION_DAYS.application_days);
        setPatientsNumber(PATIENTS_NUMBER.patients_number); setOldPatientsNumber(PATIENTS_NUMBER.patients_number);
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (isMounted()) {
        setLoading(false);
      }
    }
  }, [isMounted]);
 
  const getSteps = useCallback(async () => {
    try {
      await stepApi.getAllSteps(user.admin_id);
    } catch (err) {
      console.error(err);
    }
  }, [isMounted]);
 
  const getAudits = useCallback(async () => {
    try {
      await auditsApi.getAllAudits(user.admin_id);
    } catch (err) {
      console.error(err);
    }
  }, [isMounted]);
 
  useEffect(() => {
    const loadData = async () => {
      await Promise.all([
        getParams(),
        getSteps(),
        getAudits()
      ]);
    };
    loadData();
  }, [getParams, getSteps, getAudits]);
 
  const setParamAutomaticMail = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutomaticMail(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
 
  const handleChangeAutomaticMail = (value) => {
    setAutomaticMail(!value);
    setParamAutomaticMail(!value ? 1 : 0);
  };
 
  const setParamAutomaticMailToCustomer = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutomaticMailToCustomer(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
 
  const handleChangeAutomaticMailToCustomer = (value) => {
    setAutomaticMailToCustomer(!value);
    setParamAutomaticMailToCustomer(!value ? 1 : 0);
  };
 
  const handleChangeAutomaticMailAdminNewDevice = (value) => {
    setAutomaticMailAdminNewDevice(!value);
    setParamAutomaticMailAdminNewDevice(!value ? 1 : 0);
  };  
 
  const handleChangeAutomaticMailUserNewDevice = (value) => {
    setAutomaticMailUserNewDevice(!value);
    setParamAutomaticMailUserNewDevice(!value ? 1 : 0);
  };  
 
  const handleChangeAutomaticMailAdminFirstLogin = (value) => {
    setAutomaticMailAdminFirstLogin(!value);
    setParamAutomaticMailAdminFirstLogin(!value ? 1 : 0);
  };
 
  const handleChangeAutomaticMailUserFirstLogin = (value) => {
    setAutomaticMailUserFirstLogin(!value);
    setParamAutomaticMailUserFirstLogin(!value ? 1 : 0);
  };
 
  const setParamAutomaticMailAdminNewDevice = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutomaticMailAdminNewDevice(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
 
  const setParamAutomaticMailUserNewDevice = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutomaticMailUserNewDevice(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
 
  const setParamAutomaticMailAdminFirstLogin = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutomaticMailAdminFirstLogin(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);  
 
  const setParamAutomaticMailUserFirstLogin = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutomaticMailToCustomer(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
  const setParamAutoRelaunche = useCallback(async (value) => {
    try {
      await paramsApi.setParamAutoRelaunche(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
const setParamSendMailSameEPP = useCallback(async (value) => {
    try {
      await paramsApi.setParamSendMailSameEPP(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
const setParamTLMS_BRANCH_ID = useCallback(async (value) => {
    try {
      await paramsApi.setParamTLMS_BRANCH_ID(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
const setParamTLMS_DOMAIN = useCallback(async (value) => {
    try {
      await paramsApi.setParamTLMS_DOMAIN(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
  const setParamTLMS_ADDRESS = useCallback(async (value) => {
    try {
      await paramsApi.setParamTLMS_ADDRESS(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
  const setParamAPPLICATION_DAYS = useCallback(async (value) => {
    try {
      await paramsApi.setParamAPPLICATION_DAYS(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
const setParamPATIENTS_NUMBER = useCallback(async (value) => {
    try {
      await paramsApi.setParamPATIENTS_NUMBER(user.admin_id, value);
    } catch (err) {
      console.error(err);
    }
  }, []);
  const handleChangeAutoRelaunche = (value) => {
    setAutoRelaunche(!value);
    setParamAutoRelaunche(!value ? 1 : 0);
  };
  const handleChangeSendMailSameEPP = (value) => {
    setAutoSendMailSameEPP(!value);
    setParamSendMailSameEPP(!value ? 1 : 0);
  };
  const handleChangeAPPLICATION_DAYS = (value) => {
    setApplicationDays(value);
    setParamAPPLICATION_DAYS(value);
  };
  const handleChangePATIENTS_NUMBER = (value) => {
    setPatientsNumber(value);
    setParamPATIENTS_NUMBER(value);
  };
  const handleChangeTLMS_BRANCH_ID = (value) => {
    setTLMS_BRANCH_ID(value);
    setParamTLMS_BRANCH_ID(value);
  };
  const handleChangeTLMS_ADDRESS = (value) => {
    setTLMS_ADDRESS(value);
    setParamTLMS_ADDRESS(value);
  };
  const handleChangeTLMS_DOMAIN = (value) => {
    setTLMS_DOMAIN(value);
    setParamTLMS_DOMAIN(value);
  }; 


  if (loading) {
    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 11,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }
 
  return (
    <>
      {user.access_level === 0 ? (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 11,
          }}
        >
          <Container maxWidth="xl">
            <Box sx={{ mb: 5 }}>
              <Grid container justifyContent="space-between" spacing={3}>
                <Grid item>
                  <Typography variant="h4" sx={{ fontFamily: "Montserrat" }}>
                    Paramètres
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ mt: 3 }}>
            <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
                
                <Tooltip title="Contrôle les tâches cron">
                  <Typography>Envoi de mails automatique</Typography>
                </Tooltip><Switch
                  checked={automaticMail}
                  onChange={() => {
                    handleChangeAutomaticMail(automaticMail);
                  }}
                />
              </MenuItem>
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
               
                <Tooltip title="Contrôle l'envoi de mail à l'apprenant">
                  <Typography>
                    Envoi de mails automatique à l'apprenant
                  </Typography>
                </Tooltip> <Switch
                  checked={automaticMailToCustomer}
                  onChange={() => {
                    handleChangeAutomaticMailToCustomer(
                      automaticMailToCustomer
                    );
                  }}
                />
              </MenuItem>
 
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
               
                <Tooltip title="Contrôle les tâches cron">
                  <Typography>Vérification des emails pour la première connexion des admins</Typography>
                </Tooltip> <Switch
                  checked={automaticMailAdminFirstLogin}
                  onChange={() => {
                    handleChangeAutomaticMailAdminFirstLogin(automaticMailAdminFirstLogin);
                  }}
                />
              </MenuItem>
 
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
                
                <Tooltip title="Contrôle les tâches cron">
                  <Typography>Authentification à deux facteurs pour les admins</Typography>
                </Tooltip><Switch
                  checked={automaticMailAdminNewDevice}
                  onChange={() => {
                    handleChangeAutomaticMailAdminNewDevice(automaticMailAdminNewDevice);
                  }}
                />
              </MenuItem>
             
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
                
                <Tooltip title="Contrôle les tâches cron">
                  <Typography>Vérification des emails pour la première connexion des apprenants</Typography>
                </Tooltip><Switch
                  checked={automaticMailUserFirstLogin}
                  onChange={() => {
                    handleChangeAutomaticMailUserFirstLogin(automaticMailUserFirstLogin);
                  }}
                />
              </MenuItem>
 
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
                
                <Tooltip title="Contrôle les tâches cron">
                  <Typography>Authentification à deux facteurs pour les admins</Typography>
                </Tooltip><Switch
                  checked={automaticMailUserNewDevice}
                  onChange={() => {
                    handleChangeAutomaticMailUserNewDevice(automaticMailUserNewDevice);
                  }}
                />
              </MenuItem>
              {/* SendMailSameEPP */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
                
                <Tooltip title="Contrôle les tâches cron">
                  <Typography>Envoie des mails concernant la même EPP</Typography>
                </Tooltip><Switch
                  checked={autoSendMailSameEPP}
                  onChange={() => {
                    handleChangeSendMailSameEPP(autoSendMailSameEPP);
                  }}
                />
              </MenuItem>
              {/* AUTO RELAUNCHE */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}>
               <Tooltip title="Contrôle les tâches cron">
                  <Typography>Relance automatique</Typography>
                </Tooltip>
                 <Switch
                  checked={autoRelaunche}
                  onChange={() => {
                    handleChangeAutoRelaunche(autoRelaunche);
                  }}
                />
                
              </MenuItem>
              {/* APPLICATION DAYS */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}
              onMouseEnter={() => setHovered('days')}
              onMouseLeave={() => setHovered(null)}>
                <Typography>Jours de carence par défaut</Typography>
                {modifyAppDays? <Box sx={{ display: "flex"}}>  <TextField
                // label="Pondération"
                textAlign={"center"}
                type="number"
                sx={{width:"80px"}}
                value={applicationDays}
                onChange={(event) => {setApplicationDays(event.target.value)}}
              /> 
              <Button variant="outlined" sx={{marginLeft:"10px"}} onClick={()=> {setModifyAppDays(false);handleChangeAPPLICATION_DAYS(applicationDays)}}> Valider</Button> 
              <Button  sx={{marginLeft:"10px"}} onClick={()=> {{setModifyAppDays(false);setApplicationDays(oldApplicationDays) }}}> Annuler</Button> </Box>: 
      <Box sx={{ display: "flex"}}>   <Typography color="primary">{applicationDays} {applicationDays===1?"jour":"jours"}</Typography>
      {hovered === 'days' && (
                <Tooltip title="Modifier les jours de carence">
                  <IconButton size="small" color="primary" onClick={() => setModifyAppDays(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )} </Box> }
              </MenuItem>

              {/* PATIENTS NUMBER */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}
               onMouseEnter={() => setHovered('patients')}
      onMouseLeave={() => setHovered(null)}>
                {/* <Tooltip title="Contrôle les tâches cron"> */}
                  <Typography>Nombre de patients par défaut</Typography>
                  { modifyPatientsNumber? <Box sx={{ display: "flex"}}>  <TextField
                // label="Pondération"
                textAlign={"center"}
                type="number"
                sx={{width:"80px"}}
                value={patientsNumber}
                onChange={(event) => {setPatientsNumber(event.target.value)}}
              /> <Button variant="outlined" sx={{marginLeft:"10px"}} onClick={()=> {{setModifyPatientsNumber(false); handleChangePATIENTS_NUMBER(patientsNumber);}}}> Valider</Button>
              <Button  sx={{marginLeft:"10px"}} onClick={()=> {{setModifyPatientsNumber(false);setPatientsNumber(oldPatientsNumber); }}}> Annuler</Button>  </Box>
              : <Box sx={{ display: "flex"}}>   <Typography color="primary">{patientsNumber} {patientsNumber===1? "patient":"patients"}</Typography>
          {hovered === 'patients' && (
                <Tooltip title="Modifier le nombre de patients">
                  <IconButton size="small" color="primary" onClick={() => setModifyPatientsNumber(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              </Box>}
              </MenuItem>
            {/* TLMS BRANCHE ID */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}
               onMouseEnter={() => setHovered('tlms_branche_id')}
      onMouseLeave={() => setHovered(null)}>
                {/* <Tooltip title="Contrôle les tâches cron"> */}
                  <Typography>Identifiant de la branche TLMS</Typography>
                  { modifyTLMS_BRANCH_ID? <Box sx={{ display: "flex"}}>  <TextField
                // label="Pondération"
                textAlign={"center"}
                type="number"
                sx={{width:"80px"}}
                value={TLMS_BRANCH_ID}
                onChange={(event) => {setTLMS_BRANCH_ID(event.target.value)}}
              /> <Button variant="outlined" sx={{marginLeft:"10px"}} onClick={()=> {{setModifyTLMS_BRANCH_ID(false); handleChangeTLMS_BRANCH_ID(TLMS_BRANCH_ID)}}}> Valider</Button>
              <Button  sx={{marginLeft:"10px"}} onClick={()=> {{setModifyTLMS_BRANCH_ID(false); }}}> Annuler</Button> 
               </Box>
              : <Box sx={{ display: "flex"}}>   <Typography color="primary">{TLMS_BRANCH_ID?TLMS_BRANCH_ID:"Aucune"}</Typography>
          {hovered === 'tlms_branche_id' && (
                <Tooltip title="Modifier l'identifiant de la branche TLMS">
                  <IconButton size="small" color="primary" onClick={() => setModifyTLMS_BRANCH_ID(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              </Box>}
              </MenuItem>
              {/* TLMS ADRESS */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}
               onMouseEnter={() => setHovered('tlms_address')}
      onMouseLeave={() => setHovered(null)}>
                  <Typography>Adresse TLMS</Typography>
                  { modifyTLMS_ADDRESS? <Box sx={{ display: "flex"}}>  <TextField
                // label="Pondération"
                textAlign={"center"}
                type="text"
                sx={{width:"240px"}}
                value={TLMS_ADDRESS}
                onChange={(event) => {setTLMS_ADDRESS(event.target.value)}}
              /> <Button variant="outlined" sx={{marginLeft:"10px"}} onClick={()=> {{setModifyTLMS_ADDRESS(false); handleChangeTLMS_ADDRESS(TLMS_ADDRESS)}}}> Valider</Button>
              <Button  sx={{marginLeft:"10px"}} onClick={()=> {{setModifyTLMS_ADDRESS(false); setTLMS_ADDRESS(oldTLMS_ADDRESS);}}}> Annuler</Button> </Box>
              : <Box sx={{ display: "flex"}}>   <Typography color="primary">{TLMS_ADDRESS?TLMS_ADDRESS:"Aucune"}</Typography>
          {hovered === 'tlms_address' && (
                <Tooltip title="Modifier l'addresse TLMS">
                  <IconButton size="small" color="primary" onClick={() => setModifyTLMS_ADDRESS(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              </Box>}
              </MenuItem>
              {/* TLMS DOLAIN */}
              <MenuItem sx={{ display: "flex",justifyContent: "space-between", width:"800px"}}
               onMouseEnter={() => setHovered('tlms_domain')}
      onMouseLeave={() => setHovered(null)}>
                  <Typography>Nom du domaine TLMS</Typography>
                  { modifyTLMS_DOMAIN? <Box sx={{ display: "flex"}}>  <TextField
                // label="Pondération"
                textAlign={"center"}
                type="text"
                sx={{width:"240px"}}
                value={TLMS_DOMAIN}
                onChange={(event) => {setTLMS_DOMAIN(event.target.value)}}
              /> 
              <Button variant="outlined" sx={{marginLeft:"10px"}} onClick={()=> {{setModifyTLMS_DOMAIN(false); handleChangeTLMS_DOMAIN(TLMS_DOMAIN)}}}> Valider</Button> 
              <Button  sx={{marginLeft:"10px"}} onClick={()=> {{setModifyTLMS_DOMAIN(false); setTLMS_DOMAIN(oldTLMS_DOMAIN); }}}> Annuler</Button> </Box>
              : <Box sx={{ display: "flex"}}>   <Typography color="primary">{TLMS_DOMAIN?TLMS_DOMAIN:"Aucune"}</Typography>
          {hovered === 'tlms_domain' && (
                <Tooltip title="Modifier l'identifiant de la branche TLMS">
                  <IconButton size="small" color="primary" onClick={() => setModifyTLMS_DOMAIN(true)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              </Box>}
              </MenuItem>
            </Box>
          </Container>
        </Box>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 11,
          }}
        >
          <Container maxWidth="xl">
            <Box sx={{ mb: 5 }}>
              <Grid container justifyContent="space-between" spacing={3}>
                <Grid item>
                  <Typography>
                    Vous n'avez pas les droits pour Voir cette page
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};
 
export default Parameters;